module.exports = __webpack_public_path__ + "img/2.204ea5f6.png";